<template>

  <div class="box-table">
    <div class="horizontal-responsive">
      <table class="table-style">
        <tr>
          <th>ID Anexo</th>
          <th>Versión</th>
          <th>Fecha de firma</th>
        </tr>
        <tr v-for="annex in annexList.results" :key="annex.id">
          <td>{{ annex.id }}</td>
          <td>{{ annex.annex_version }}</td>
          <td>{{ dateFormat(annex.signed_at) }}</td>
        </tr>
      </table>
      <p class="-centered-info"><small>{{ currentPage }} de {{ totalPages }}</small></p>
    </div>
    <div class="table-pagination -centered-info">
      <button
        class="button button-small"
        @click="paginationTable(annexList.previous, 'previous')"
        :disabled="annexList.previous === null">Anterior</button>
      <button
        class="button button-small"
        @click="paginationTable(annexList.next)"
        :disabled="annexList.next === null">Siguiente</button>
    </div>
  </div>

</template>

<script>

import mixins from '@/mixins/index'
import httpRequestMixin from '@/mixins/httpRequestMixin'
export default {
  name: 'UserProfileAnnexes',
  data () {
    return {
      annexList: [],
      totalPages: 1,
      currentPage: 1
    }
  },
  mixins: [mixins, httpRequestMixin],
  methods: {
    getUserAnnexes: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/annexes/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.annexList = response.data
      }
    }
  },
  created: function () {
    this.getUserAnnexes()
    if (this.annexList.count >= 10) {
      this.totalPages = Math.round(this.annexList.count / 10)
    }
  }
}

</script>

<style lang="scss" scoped>

.state {
  text-transform: capitalize;
}

.table-pagination {
  margin-top: 2rem;
}

.table-style {

  td,
  th {
    font-size: .9em;
    line-height: 1.2;
  }
  th b {
    color: #999;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/userProfileResume/UserProfileAnnexes.vue